<script>
/* eslint-disable */
</script>
<template>
  <div class="notification-widget"></div>
</template>

<script>
export default {
    components: {},
    data() {
      return { }
    },
    props: [],
    computed: {
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/external/media-manager/NotificationWidget.vue